import { gql } from '@apollo/client';
import { META_DATA_QUERY_FIELDS } from 'src/graphql/entities/metadata.fragments';

export const GET_ADDRESS_SUMMARY_QUERY = gql`
  query GetAddressSummary($params: QueryParams, $skipTotalRecords: Boolean = false) {
    getAddressSummary(queryParams: $params) {
      records {
        id
        addressSummaryId
        addressId
        partnerId
        shortSummary
        # jsonb, delivered as a JSON string — parsed by parseSiteOverview.
        intermediateSummary
        createdAt
        updatedAt
      }
      metadata {
        ...MetaDataQueryFields
      }
    }
  }
  ${META_DATA_QUERY_FIELDS}
`;

export const GENERATE_ADDRESS_SUMMARY_MUTATION = gql`
  mutation GenerateAddressSummary($input: GenerateAddressSummaryInput!) {
    generateAddressSummary(input: $input) {
      id
      addressSummaryId
      addressId
      partnerId
      shortSummary
      intermediateSummary
      createdAt
      updatedAt
    }
  }
`;
